import Hammer from 'hammerjs';

document.addEventListener("alpine:init", () => {

	window.Alpine.data('banner', () => ({
		isLoading: true,
		isChanging: false,
		isStatic: true,
		slides: null,
		current: 0,
		next: 0,
		total: 1,
		timeout: 500,
		autoplayInterval: 7500,
		timer: null,
		init() {
			
			this.slides = this.$refs.carousel.querySelectorAll('.slide');
			
			this.total = this.slides.length;
			
			if( this.total < 2 ){
				this.changeSlide(0);
			}else{
				this.isStatic = false;
				this.startAutoplay();
			}

			new Hammer( this.$refs.carousel ).on('swipeleft swiperight', function(ev) {
				if( ev.type == 'swipeleft' ){
					this.nextSlide();
				}else{
					this.prevSlide();
				}
			}.bind(this));

			this.isLoading = false;
		},

		startAutoplay() {
			this.timer = setInterval(() => {
				this.nextSlide();
			}, this.autoplayInterval);
		},
  
		stopAutoplay() {
			clearInterval(this.timer);
		},
  
		resetAutoplay() {
			this.stopAutoplay();
			this.startAutoplay();
		},

		nextSlide() {
			if( this.current == ( this.total - 1 ) ){
				this.changeSlide(0);
			}else{
				this.changeSlide( this.current + 1 );
			}
		},

		prevSlide() {
			if( this.current == 1 ){
				this.changeSlide( this.total - 1 );
			}else{
				this.changeSlide( this.current - 1 );
			}
		},

		async changeSlide( nextItem ) {

			if( nextItem === this.current ){
				return;
			}
			
			this.next = nextItem;
			this.isChanging = true;

			const current = await new Promise((resolve) => {
				setTimeout(() => {
					resolve(this.next);
				}, this.timeout);
			});

			this.current = nextItem;

			setTimeout(() => {
				this.isChanging = false;
			}, this.timeout / 2);

			if( !this.isStatic ){
				setTimeout(() => {
					this.resetAutoplay();
				}, this.timeout);
			}

		}
	}));

});